module.exports = __webpack_public_path__ + "static/media/ig.83bdb110.png";